import { render } from "./config-logo.vue?vue&type=template&id=371129da"
import script from "./config-logo.vue?vue&type=script&lang=js"
export * from "./config-logo.vue?vue&type=script&lang=js"

import "./config-logo.vue?vue&type=style&index=0&id=371129da&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__